import { styled } from '../../../utils';
import { Colors, GridBreakpointsMediaDown } from '../../../const';
import { HeadingStyled } from '../../heading/heading.styled';
import { BoxStyled } from '../../box';
import { ImgStyled } from '../../img';
import { PageErrorProps } from '../types';
import React, { FC } from 'react';

const PageErrorChild: FC<PageErrorProps> = ({ className, children }) => <div className={className}>{children}</div>;
export const PageErrorStyled = styled(PageErrorChild)`
  min-height: calc(100vh - 85px);
  box-sizing: border-box;
  background-color: ${Colors.gray100};
  padding: 15px 0;
  display: flex;
  align-items: center;
  ${HeadingStyled} {
    margin: 0 0 20px;
    ${GridBreakpointsMediaDown.sm} {
      margin: 0 0 15px;
      text-align: center;
    }
  }
  ${BoxStyled} {
    margin: 0 0 40px;
    white-space: pre-line;

    ${GridBreakpointsMediaDown.sm} {
      margin: 0 0 25px;
      text-align: center;
    }
  }

  ${ImgStyled} {
    max-width: 100%;
    margin: 0 auto;
    display: block;
    ${GridBreakpointsMediaDown.sm} {
      max-width: 290px;
      margin: 0 auto 20px;
    }
  }
`;
